import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import axios from "axios";

import {signIn} from '../../routes/UserAction';
import { domainUrl } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
// import './contact.css'

export default function LoginPage() {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const customAlertRef = useRef()

    const { loading, user, error, success, successMessage,} = useSelector((state) => state.user || {});

    useEffect(() => {

        const userToken = localStorage.getItem('userToken')
        ? localStorage.getItem('userToken')
        : null
        if (userToken !== null) {
          navigate('/')
        }
    
    }, [navigate, user, success])

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
        (pos) => {
            setLocation({
            lat: pos.coords.latitude,
            long: pos.coords.longitude,
            });
        },
        (err) => console.warn('Geolocation error:', err)
        );
    }, []);

    const [hovered, setHovered] = useState(false);

    const [errorMsg, setErrorMsg] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [sendSMS, setSendSMS] = useState(false);
    const [sendEmail, setSendEmail] = useState(true);

    const [location, setLocation] = useState(null);

    const detectInputType = (value) => {
        const intlPhoneRegex = /^\+\d{10,15}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        if (/^\d{10,15}$/.test(value)) {
            alert("Please enter phone numbers in international format, e.g., +233559148214");
            return 'invalidPhone';
        }
    
        if (intlPhoneRegex.test(value)) return 1; // phone
        if (emailRegex.test(value)) return 2;     // email
        return 3;                                 // username
    };
    
    const sanitizePhone = (value) => value.startsWith('+') ? value.slice(1) : value;

    const handlePasswordLogin = () => {

        if (!email || !password) {
            alert('Please fill in both email/phone/username and password fields.');
            return;
        }
    
        const inputType = detectInputType(email);
    
        
        if (inputType === 'invalidPhone') {
            alert("Phone number must start with '+' and be in international format.");
            return;
        }
    
        const processedEmail = inputType === 1 ? sanitizePhone(email) : email;
    
        setSubmitting(true);
    
        dispatch(signIn({
            email: processedEmail,
            password,
            isCode: 0,
            isPhone: inputType, // phone =1, email =2, username =3
            lat: location?.lat,
            long: location?.long,
        }))
        .then((response) => {
            // if (!response?.success) {
            //     // console.log('Login error:', response?.message);
            //     alert(error);
            // } else {

            //     console.log('response', response)
            //     // navigate('/');
            // }
        })
        .catch((error) => {
            alert(error);
            console.log('Dispatch error:', error);
        })
        .finally(() => {
            setSubmitting(false);
        });
    };

    const getLoginCode = async () => {

        if (!email) {
            alert('Please fill in both email/phone/username');
            return;
        }

        const inputType = detectInputType(email);
    
        
        if (inputType === 'invalidPhone') {
            alert("Phone number must start with '+' and be in international format.");
            return;
        }
    
        const processedEmail = inputType === 1 ? sanitizePhone(email) : email;

        try {
          const { data } = await axios.post(`${domainUrl}/get_login_code`, { 
            email: processedEmail,
            isPhone: inputType, // phone =1, email =2, username =3
            sendEmail,
            sendSMS,
            lat: location?.lat,
            long: location?.long,
          });
    
          if (data.success) {
            alert(data.message);
          } else {
            alert(data.message);
          }
        } catch (err) {
            if (err.response) {
                alert("Error: " + JSON.stringify(err.response.data.message || err.response.data));
            } else if (err.request) {
                alert("Error: No response received from server" );
            } else {
                alert("Error: Error setting up request" );
            }
        }
    };

    const handleCodeLogin = () => {
        //  setSubmitting(true);

        if (!email || !code) {
            alert('Please fill in both email/phone/username and code fields.');
            return;
        }

        const inputType = detectInputType(email);
    
        
        if (inputType === 'invalidPhone') {
            alert("Phone number must start with '+' and be in international format.");
            return;
        }
    
        const processedEmail = inputType === 1 ? sanitizePhone(email) : email;
    
        setSubmitting(true);
        
        dispatch(signIn({
            email: processedEmail,
            code, 
            isCode: 1,
            isPhone: inputType, // phone =1, email =2, username =3
            lat: location?.lat,
            long: location?.long,
        }))
        .then((response) => {
            // if (!response?.success) {
            //     // console.log('Login error:', response?.message);
            //     alert(error);
            // } else {

            //     console.log('response', response)
            //     // navigate('/');
            // }
        })
        .catch((error) => {
            console.log('Dispatch error:', error);
        })
        .finally(() => {
            setSubmitting(false);
        });
    };

    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'contact'}/>

            
            {/* <!-- Contact Start --> */}
            <div className="container-fluid contact py-5">
                <div className="container py-5">
                    <div className="row g-5">
                        
                        <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.4s">
                            <div className="form-section bg-success p-5 h-100">
                                <h1 className="display-4 text-white mb-4">Login</h1>
                                <h5 className="text-warning mb-4">Acceped Phone: International Format (+...)</h5>
                                <form>
                                    <div className="row g-4">
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input type="text" className="form-control border-0" id="email" placeholder="Email/Phone" onChange={(e) => setEmail(e.target.value)}/>
                                                <label htmlFor="email">Email/Phone/Username</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="form-control border-0" id="password" placeholder="Password"/>
                                                <label htmlFor="password">Password</label>
                                            </div>
                                        </div>
                                        
                                        
                                        <div className="mx-auto col-lg-12 col-xl-6">
                                            <div className="form-section-col">
                                                <button type='button' onClick={handlePasswordLogin} className="btn-primary w-100 py-3 px-5">Login</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.4s">
                            <div className="form-section bg-success p-5 h-100">
                                <h1 className="display-4 text-white mb-4">Use Code</h1>

                                
                                
                                <h5 className="text-warning mb-4">Acceped Phone: International Format (+...)</h5>

                                <form>
                                    <div className="row g-4">
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input type="email" value={email} className="form-control border-0" id="email" placeholder="Email/Phone" onChange={(e) => setEmail(e.target.value)}/>
                                                <label htmlFor="email">Email/Phone</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input type="text" className="form-control border-0" id="code" placeholder="OPT" onChange={(e) => setCode(e.target.value)} value={code}/>
                                                <label htmlFor="code">OTP</label>
                                            </div>
                                        </div>

                                        <div className='row mt-2 mx-2'>
                                            <div className='col-6'>
                                                <input 
                                                    type="checkbox" 
                                                    className="form-check-input" 
                                                    id="sendSMS" 
                                                    checked={sendSMS}
                                                    onChange={(e) => setSendSMS(e.target.checked)}
                                                />
                                                <label className="form-check-label text-white mx-2" htmlFor="sendSms">
                                                    Send SMS
                                                </label>
                                            </div>
                                            <div className='col-6'>
                                                <input 
                                                    type="checkbox" 
                                                    className="form-check-input" 
                                                    id="sendEmail" 
                                                    checked={sendEmail}
                                                    onChange={(e) => setSendEmail(e.target.checked)}
                                                />
                                                <label className="form-check-label text-white mx-2" htmlFor="sendEmail">
                                                    Send Email
                                                </label>
                                            </div>
                                        </div>
                                        
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-section-col">
                                                <button type='button' className="btn-primary w-100 py-3 px-5" onMouseEnter={() => setHovered(true)}
                                                onMouseLeave={() => setHovered(false)}
                                                style={{
                                                    backgroundColor: hovered ? 'white' : '#DAA520',
                                                    color: hovered ? '#000' : '#000',
                                                    transition: 'background-color 0.3s ease',
                                                }} onClick={getLoginCode}>Get Code</button>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-section-col">
                                                <button type='button' onClick={handleCodeLogin} className="btn-primary w-100 py-3 px-5">Verify Code</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- Contact End --> */}

        <Footer/>
        </>
    );
}
